import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { AddVehicleRequest } from '../models/request/vehicle/AddVehicleRequest';
import { GetVehicleListPagingAndFilterRequest } from '../models/request/vehicle/GetVehicleListPagingAndFilterRequest';

/** Araç QR kodu (11.10.2026): şoför araçtaki QR'ı okutur (bilgi amaçlı: konum + süre). */
export interface AracQrKodu {
    vehicleId: string
    plaka: string
    qrKodu: string
    qrMetni: string
}

export class VehicleService {
    /** Seçilen araçların QR kodları; kodu olmayan araç için backend üretir. */
    static async qrKodlari(_ids: string[]): Promise<{ isSuccess: boolean, message?: string, data: AracQrKodu[] }> {
        try {
            var inputObj = { ids: _ids };

            console.log('SERVICE CALL - Vehicle/QrKodlari', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Vehicle/QrKodlari', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    /** Aracın QR kodunu yeniler; eski etiket artık çalışmaz. */
    static async qrYenile(_id: string): Promise<{ isSuccess: boolean, message?: string, data: AracQrKodu }> {
        try {
            var inputObj = { id: _id };

            console.log('SERVICE CALL - Vehicle/QrYenile', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Vehicle/QrYenile', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async exportVehicleList(inputObj: GetVehicleListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - exportVehicleList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Vehicle/exportVehicleList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getVehicleListPagingAndFilter(inputObj: GetVehicleListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - GetVehicleListPagingAndFilter', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Vehicle/GetVehicleListPagingAndFilter', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static getFormData(obj: any = {}, formData = new FormData(), key = '') {
        if (!([Array, File, Object].includes(obj.constructor))) {
            return formData;
        }

        // Handle File recursive
        if (obj instanceof File) {
            formData.append(key, obj);
            return formData;
        }

        for (const prop in obj) {
            // Validate value type
            if (obj[prop] && !([String, Number, Boolean, Array, Object, File].includes(obj[prop].constructor))) {
                continue;
            }

            // Set deep index of prop
            const deepKey = key ? key + `.${prop}` : prop;

            // Handle array
            if (Array.isArray(obj[prop])) {
                obj[prop].forEach((item: any, index: any) => {
                    this.getFormData(item, formData, `${deepKey}[${index}]`);
                })
                continue;
            }

            (typeof obj[prop] === 'object' && obj[prop] && obj[prop].constructor === Object)
                ? this.getFormData(obj[prop], formData, deepKey) // Handle object
                : formData.append(deepKey, [undefined, null].includes(obj[prop]) ? '' : obj[prop]) // Handle string, number, boolean
        }

        return formData;
    }

    static async addVehicle(inputObj: AddVehicleRequest) {
        try {
            const formData = this.getFormData(inputObj);

            console.log('SERVICE CALL - AddVehicle', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Vehicle/AddVehicle', formData);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async deleteVehicle(_ids: string[]) {
        try {
            var inputObj = {
                ids: _ids
            };

            console.log('SERVICE CALL - deleteVehicle', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Vehicle/deleteVehicle', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getVehicleById(_id: string) {
        try {
            var inputObj = {
                id: _id
            };

            console.log('SERVICE CALL - getVehicleById', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Vehicle/getVehicleById', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getVehicleList(_vehicleTypeKeys: string[] | undefined = undefined, _vehicleTypeKeysNot: string[] | undefined = undefined, _companyId: string | undefined = undefined) {
        try {
            var inputObj = {
                vehicleTypeKeys: _vehicleTypeKeys,
                vehicleTypeKeysNot: _vehicleTypeKeysNot,
                companyId: _companyId
            };

            console.log('SERVICE CALL - getVehicleList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Vehicle/getVehicleList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }
}